// extracted by mini-css-extract-plugin
module.exports = {"fieldSet":"InspectorFieldSet_fieldSet__3GPho","label":"InspectorFieldSet_label__1dbeZ","values":"InspectorFieldSet_values__nZL8J","value":"InspectorFieldSet_value__1fkzB"};